import React from 'react';
import { GraduationCap } from 'lucide-react';

const LoadingSpinner = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-500 to-green-500">
      <div className="text-center">
        <div className="flex justify-center items-center mb-4">
          <div className="bg-white p-4 rounded-full shadow-lg animate-pulse">
            <GraduationCap className="w-12 h-12 text-blue-600" />
          </div>
        </div>
        <h2 className="text-2xl font-bold text-white mb-2">EduScope</h2>
        <p className="text-blue-100 mb-6">Chargement en cours...</p>
        <div className="flex justify-center">
          <div className="spinner-large" />
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
